import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Title } from './Title';
import { FinalSaleItems } from './FinalSaleItems';
import { DeadOnArrival } from './DeadOnArrival';
import { Returns } from './Returns';
import { Warranties } from './Warranties';
export function ReturnsPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-761">
      <Header data-id="element-762" />
      <main className="flex-grow pt-32 pb-20" data-id="element-763">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-764">
          <Title data-id="element-765" />
          <div className="space-y-10 text-gray-800 leading-relaxed" data-id="element-766">
            <FinalSaleItems data-id="element-767" />
            <DeadOnArrival data-id="element-768" />
            <Returns data-id="element-769" />
            <Warranties data-id="element-770" />
          </div>
        </div>
      </main>
      <Footer data-id="element-771" />
    </div>;
}